import { useEffectOnce } from 'react-use';
import type { BootstrapBrowser } from './BootstrapBrowser';

export { RpErrorBoundary } from './components/RpErrorBoundary';

export { BootstrapBrowser, BootstrapBrowserBuilder, Bootstrap } from './BootstrapBrowser';

type Export = { bootstrap: BootstrapBrowser } | { default: BootstrapBrowser };
export const useBootstrap = (loader: () => Promise<Export> | Export) => {
  useEffectOnce(() => {
    Promise.resolve(loader())
      .then((instance) => ('bootstrap' in instance ? instance.bootstrap : instance.default))
      .then((instance) => instance.register())
      .catch(() => null);
  });
};
